'use strict'

import EventEmitter from 'event-emitter'

export const EventBus = new EventEmitter()
